//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      radio: '2'
    };
  },
  created: function created() {
    this.$emit('change', this.radio);
  },
  methods: {
    handleChange: function handleChange(v) {
      this.$emit('change', v);
    }
  }
};